import type React from 'react';
import { lazy, Suspense } from 'react';
import { PageLoading } from '@/app/components/page-loading.tsx';

const LazyNotifications = lazy(() => import('./Notifications.tsx'));

const Notifications = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={<PageLoading />}>
    <LazyNotifications {...props} />
  </Suspense>
);

export const notificationsRoute = {
  path: '/notifications',
  element: <Notifications />,
};

export default Notifications;
